import React, { useState } from 'react';
import { ActivityNoteReminderContent } from '@/experiences/sales-portal/containers/activity-note-panel/components/activity-note-reminder-content';
import { ActivityNoteReminderPickerProps } from '@/experiences/sales-portal/containers/activity-note-panel/components/activity-note-reminder-picker/types';
import { ActivityNoteReminderPill } from '@/experiences/sales-portal/containers/activity-note-panel/components/activity-note-reminder-pill';
import { createStyles } from '@/contexts/theme-context';
import { Popover } from '@usepepper/sprout-kit-ui';
import { View } from 'react-native';

export const ActivityNoteReminderPicker: React.FC<
  ActivityNoteReminderPickerProps
> = ({ onSetReminder, reminder }) => {
  const [styles] = useStyles();
  const [isOpen, setIsOpen] = useState(false);

  // prevent clicks from passing through and closing the side panel
  const stopPointerPropagation = (event: React.SyntheticEvent) => {
    event.stopPropagation();
  };

  return (
    <Popover onOpenChange={setIsOpen} open={isOpen} placement="bottom-start">
      <Popover.Anchor asChild>
        <View>
          <ActivityNoteReminderPill
            isOpen={isOpen}
            onPress={() => setIsOpen((prev) => !prev)}
            reminder={reminder}
          />
        </View>
      </Popover.Anchor>
      <Popover.Content style={styles.popoverContent}>
        <div
          onMouseDown={stopPointerPropagation}
          onTouchStart={stopPointerPropagation}
          style={styles.popoverContentContainer}
        >
          <ActivityNoteReminderContent
            onClose={() => setIsOpen(false)}
            onSetReminder={onSetReminder}
            reminder={reminder}
          />
        </div>
      </Popover.Content>
    </Popover>
  );
};

const useStyles = createStyles((theme) => ({
  popoverContent: {
    padding: theme.sk.spacing.spaceMedium,
  },
  popoverContentContainer: {
    display: 'contents',
  },
}));
